(function($) {
  let menu_open_body_class = 'mobile-menu-open';
	$(function() {
    $('.newsletter-subscribe-form').on('submit', sailSubscribeToNewsletter);
    $('.scroll-top-btn').on('click', sailScrollToTop);
    $('.mobile-menu-btn').on('click', sailOpenMobileMenu);
    $('.close-menu-btn, body').on('click', sailCloseMobileMenu);
    $('.menu-item-has-children > a, .mobile-back-menu-btn').on('click', sailMobileMenuChangeLevel);
    $('.more-cat-btn').on('click', sailShowHiddenSubCats)
    $('.show-tags').on('click', sailShowHiddenTags)
    $('.anchor-navigation').on('click', sailAnchorNavigation);
    $(window).on('scroll', sailOnScrollActions);
    $('.sail-faq-question').on('click', sailFaqAccordeon)
    $('.single-post .main-container a').each(sailProcessLink);

    //Prevents the click in the menu and the open button from closing the menu and being considered as a click on the body
    $('.main-header-menu, .mobile-menu-btn').on('click', function(event){
        event.stopPropagation();
    });

    // Handler for .ready() called.
    $('.inline-popup-link').magnificPopup({
      type:'inline',
      midClick: true // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
    });

    // Carousel
    $('.sail-carousel').slick({
      infinite: true,
      lazyLoad: 'progressive',
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: '<a href="#" class="sail-nav-btn previous"></a>',
      nextArrow: '<a href="#" class="sail-nav-btn next"></a>',
    });

    //If the nosto script exists
    if(typeof nostojs !== 'undefined'){
      console.log('Nosto loaded');

      // Initialize the Nosto recommendation carousel
      nostojs(function(api) {
        api.listen('postrender', function(event) {
          $('.nosto_element .products.list').slick({
            infinite: true,
            lazyLoad: 'progressive',
            slidesToShow: 4,
            slidesToScroll: 1,
            prevArrow: '<a href="#" class="products-nav-btn previous"></a>',
            nextArrow: '<a href="#" class="products-nav-btn next"></a>',
            responsive: [
              {
                breakpoint: 800,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1,
                }
              },
            ]
          });
        });
      });

      // Trigger a custom event to let GTM know that Nosto is ready
      dataLayer.push({'event': 'nostoReady'});
    };

  });

  /**
   * 
   * Function called on the newsletter subscription form submit action. Used to call via AJAX our newsletter subscription function. 
   * @returns 
   */
  function sailSubscribeToNewsletter(e){
    var $form = $(this);
    var email = $form.find('input[name="email"]').val();
    var $feedback_tag = $form.find('.feedback');
    var $loader = $form.find('.loading-icon');
  
    if(email){
      $.ajax({
        url: ajax.ajaxurl,
        type: 'post',
        data: {
          action: 'newsletter_subscribe',
          form: $form.serialize(),
        },
        beforeSend: function () {
          $loader.removeClass('hidden');
          $feedback_tag.addClass('hidden');
        },
        success: function (result) {
          $loader.addClass('hidden');
          var response = JSON.parse(result);
          if(response.error == false){
            $feedback_tag.html('<span class="text-sailGreen-500">' + strings.newsletter_success + '</span>');
            $feedback_tag.removeClass('hidden');
          }
          else{
            $feedback_tag.html('<span class="text-red-500">' + strings.newsletter_error + '</span>');
            $feedback_tag.removeClass('hidden');
          }
        },
        error: function(xhr, status, error){
          $loader.addClass('hidden');
          $feedback_tag.html('<span class="text-red-500">' + strings.newsletter_error + '</span>');
          $feedback_tag.removeClass('hidden');
        }
      });
    }
    return false;
  }

  /**
   * Function called on the scroll to top button. Used to scroll at the top of the page.
   * @param {*} e 
   */
  function sailScrollToTop(e) {
    e.preventDefault();
    $("html, body").animate({ scrollTop: "0px" }, 1000);
  }

  
  /**
   * Function called everytime a scroll happens on the page. Used to handle all actions that need to happen on scroll.
   * @param {*} e 
   */
  function sailOnScrollActions(e) {
    let scroll_top_value = $(window).scrollTop();
    
    //Display or hide the scroll to top button
    if(scroll_top_value > 300) {
      $('.scroll-top-btn').removeClass('opacity-0');
    }
    else {
      $('.scroll-top-btn').addClass('opacity-0');
    }

    //Hide the header tagline
    if(scroll_top_value > 1) {
      $('.tagline').slideUp(250);
    }
    else{
      $('.tagline').slideDown(250);
    }
  }

  function sailOpenMobileMenu(e) {
    e.preventDefault();
    $('body').addClass(menu_open_body_class);
  }

  function sailCloseMobileMenu(e) {
    if($('body').hasClass(menu_open_body_class)){
      e.preventDefault();
      $('body').removeClass(menu_open_body_class);
    }
  }

  /**
   * Function used to handle our mobile menu multilevel navigation process
   * @param {} e 
   */
  function sailMobileMenuChangeLevel(e) {
    if($(window).width() < 1024){
      //First, hide all menu links
      $(this).parents('.menu').find('.menu-item > a, a.menu-item').css('display', 'none');
      
      //Get the sub menu we need to show it's children links
      let $submenu_to_show = $(this).next('.sub-menu');
      
      //If we're going back one level with the back button
      if($(this).hasClass('mobile-back-menu-btn')) {
        $submenu_to_show = $(this).parent('.sub-menu');
        //If the back button brings us back to the first level of the navigation, the parent div will be different
        if($submenu_to_show.hasClass('submenu-depth-0')) {
          $submenu_to_show = $submenu_to_show.parents('.menu');
        }
        else {
          $submenu_to_show = $submenu_to_show.parents('.sub-menu');
        }
      }
  
      $submenu_to_show.find('> a').css('display', 'block');
      $submenu_to_show.find('> div > .menu-item > a, > .menu-item > a').each(function() {
        $(this).css('display', 'block');
      });
  
      e.preventDefault();
    }
  }

  /**
   * Function used to show hidden categories on mobile in the "Category" template.
   * @param {*} e 
   */
  function sailShowHiddenSubCats(e) {
    e.preventDefault();
    //Show hidden categories
    $('.category-teaser').removeClass('hidden');
    //Hide the show more button
    $(this).parent().addClass('hidden');
  }

  /**
   * Function used to show hidden tags in a post template.
   * @param {*} e 
   */
  function sailShowHiddenTags(e) {
    e.preventDefault();
    //Show hidden categories
    $('.tag-item').removeClass('hidden');
    //Hide the show more button
    $(this).addClass('hidden');
  }

  /**
   * Called on anchor links with the "anchor-navigation" class. Makes an inner page navigation based ton the links href
   * @param {*} e 
   */
  function sailAnchorNavigation(e) {
    e.preventDefault()
    let target_id = $(this).attr('href');
    $("html, body").animate({ scrollTop: $(target_id).offset().top - $('.main-header').height() - 10 }, 1000);
  }

  /**
   * Function used to show answer of faq question.
   * @param {*} e 
   */
  function sailFaqAccordeon(e) {
    $(this).toggleClass('open');
    $(this).parent().find('.sail-faq-answer').slideToggle('normal');
  }

  /**
   * Function called on links to apply target="_blank" by default to any outside link.
   */
  function sailProcessLink() {
    const link = $(this);
    const href = link.attr('href');

    // Check if the link does not start with the WordPress installation URL, "#" for anchors, or "/" for relative paths
    if (href && !href.startsWith(wpVars.siteUrl) && !href.startsWith('#') && !href.startsWith('/')) {
      // Check if the link does not already have target="_blank"
      if (!link.attr('target')) {
        link.attr('target', '_blank');
      }
    }
  }
})( jQuery );